import register from './core';

register('ai-chat', function (element) {
  function switchLanguage(newLocale) {
    localStorage.setItem('preferredLocale', newLocale);
    window.location.reload();
  }

  (async function () {
    // Common parameters function
    const getCommonParams = (locale) => ({
      language: locale,
      currentURL: window.location.href,
      timestamp: new Date().toISOString(),
      orderId: 9999,
      userTimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
    });

    const styleOptions = {
      accent: '#00809d',    
      timestampFormat: 'absolute',
      rootHeight: '60%',
      rootWidth: '100%',
      backgroundColor: '#FFFFFF',
      hideUploadButton: true,
      sendBoxPlaceholder: 'Skriv något här...', 
      sendBoxTextWrap: true, 
      sendBoxMaxHeight: 100, 
      sendBoxTextGrow: true, 
      sendBoxHeight: 60 
    };

    const element = document.querySelector('[data-component="ai-chat"]');
    const currentLocale = element ? element.dataset.language : 'sv-SE';
    const elementTokenEndPointUrl = element ? element.dataset.tokenEndpointUrl : null;
    const tokenEndpointURL = new URL(elementTokenEndPointUrl);

    document.documentElement.lang = currentLocale.split('-')[0];

    const apiVersion = tokenEndpointURL.searchParams.get('api-version');

    //const customStrings = {
    //  SEND_BOX_PLACEHOLDER: 'Din egen text här...', // Ändra denna text
    //  // Andra eventuella översättningar kan också läggas till här
    //};

    const [directLineURL, token] = await Promise.all([
      fetch(new URL(`/powervirtualagents/regionalchannelsettings?api-version=${apiVersion}`, tokenEndpointURL))
        .then(response => response.json())
        .then(({ channelUrlsById: { directline } }) => directline),
      fetch(tokenEndpointURL)
        .then(response => response.json())
        .then(({ token }) => token)
    ]);

    const directLine = WebChat.createDirectLine({
      domain: new URL('v3/directline', directLineURL),
      token
    });

    const store = WebChat.createStore({}, ({ dispatch }) => next => action => {
      if (action.type === 'DIRECT_LINE/CONNECT_FULFILLED') {
        dispatch({
          type: 'WEB_CHAT/SEND_EVENT',
          payload: {
            name: 'webchat/join',
            type: 'event',
            value: getCommonParams(currentLocale)
          }
        });
      }

      if (action.type === 'WEB_CHAT/SEND_MESSAGE') {
        return next({
          ...action,
          payload: {
            ...action.payload,
            channelData: getCommonParams(currentLocale)
          }
        });
      }

      return next(action);
    });

    const subscription = directLine.connectionStatus$.subscribe({
      next(value) {
        if (value === 2) {
          directLine
            .postActivity({
              type: 'event',
              name: 'startConversation',
              locale: currentLocale,
              localTimezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
              value: getCommonParams(currentLocale)
            })
            .subscribe();

          subscription.unsubscribe();
        }
      }
    });

    WebChat.renderWebChat(
      {
        directLine,
        locale: currentLocale,
        styleOptions,
        userID: `user_${Date.now()}`,
        username: 'WebChat User',
        store
      },
      document.getElementById('webchat')
    );

    console.log(window.WebChat.version);

    setTimeout(() => {
      const inputBox = document.querySelector('.webchat__send-box-text-box__input');
      if (inputBox) {
        if (currentLocale == 'sv-SE') {
          inputBox.placeholder = 'Ställ en fråga';
        }
        else {
          inputBox.placeholder = 'Ask a question';
        }       
      } else {
        console.warn('Input element not found after timeout');
      }
    }, 500);
  })();
});


